import { FC, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import { FaTimes } from 'react-icons/fa';
import cn from 'classnames';

import { useOutsideAlerter } from '@helpers/useOutsideAlerter';

import Button from '@components/Button';

import './Modal.scss';

type ModalProps = {
  opened: boolean;
  title?: string;
  onClose?: () => void;
  style?: {
    [key: string]: any;
  };
  footer?: boolean;
  invertedColors?: boolean;
  crossButton?: boolean;
  modalClass?:string;
  isSticky?: boolean;
};

const Modal: FC<ModalProps> = ({
  opened,
  title,
  children,
  style,
  invertedColors,
  onClose,
  footer = true,
  crossButton,
  modalClass,
  isSticky
}) => {
  const modalRef = useRef(null);

  const handleClose = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  useOutsideAlerter(modalRef, handleClose, isSticky);
        

  if (!opened) return null;

  return createPortal(
    <div
      className={cn('modal', modalClass, {
        'modal_inverted-colors': invertedColors,
      })}
    >
      <div className="modal__window pb-3" ref={modalRef} style={style}>
        {title?<div className="modal__title">
          <span>{title}</span>
          {crossButton && (
            <div className="modal__close-buttom" onClick={handleClose}>
              <FaTimes />
            </div>
          )}
        </div>:null}
        <div className="modal__content">{children}</div>
        {footer && !crossButton &&  (
          <div className="modal__footer">
            <Button label="Close" withBorder onClick={handleClose} />
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
